
export const BASE_END_POINT = 'https://api-stg.byitapp.com/api/v1/' 